/**
 * View component for /siteLocations/new
 *
 * Creates a new siteLocation from a copy of the defaultItem in the siteLocation reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as siteLocationActions from '../siteLocationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import utilities
import mapUtils from '../../../global/utils/mapUtils';

// import siteLocation components
import SiteLocationForm from '../components/SiteLocationForm.js.jsx';
import SiteLocationLayout from '../components/SiteLocationLayout.js.jsx';

class AdminCreateSiteLocation extends Base {
  constructor(props) {
    super(props);
    this.state = {
      siteLocation: _.cloneDeep(this.props.defaultSiteLocation)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , formHelpers: {}
      /**
       * NOTE: formHelpers are useful for things like radio controls and other
       * things that manipulate the form, but don't directly effect the state of
       * the siteLocation
       */
    }
    this._bind(
      '_handleFormChange'
      , '_handleMapSearch'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, () => {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleMapSearch(mapObj) {
    console.log(mapObj);
    let newSiteLocation = _.cloneDeep(this.state.siteLocation);
    newSiteLocation.formatted_address = mapObj[0].formatted_address;
    newSiteLocation.address = mapUtils.extractAddress(mapObj[0].address_components);
    newSiteLocation.geo.coordinates[0] = mapObj[0].geometry.location.lng();
    newSiteLocation.geo.coordinates[1] = mapObj[0].geometry.location.lat();
    newSiteLocation.mapZoom = 16;
    this.setState({siteLocation: newSiteLocation});
    // console.log(newSiteLocation);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(siteLocationActions.sendCreateSiteLocation(this.state.siteLocation)).then((action) => {
      if(action.success) {
        dispatch(siteLocationActions.invalidateList());
        history.push(`/admin/site-locations/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const { siteLocation, formHelpers } = this.state;
    const isEmpty = (siteLocation.name === null || siteLocation.name === undefined);
    return (
      <div className="flex">
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={this.props.location.state.breadcrumbs}/>
          </div>
          {isEmpty ?
            <h2> Loading...</h2>
            :
            <SiteLocationForm
              siteLocation={siteLocation}
              cancelLink="/admin/site-locations"
              formHelpers={formHelpers}
              formTitle="Create Site/Team Location"
              formType="create"
              handleFormChange={this._handleFormChange}
              handleMapSearch={this._handleMapSearch}
              handleFormSubmit={this._handleFormSubmit}
            />
          }
        </section>
      </div>
    )
  }
}

AdminCreateSiteLocation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultSiteLocation: store.siteLocation.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateSiteLocation)
);



// WEBPACK FOOTER //
// modules/siteLocation/views/AdminCreateSiteLocation.js.jsx